import { CategoryItem, CategoryListAtacado } from "../../components/CategoryItem";
import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import './index.css'
import { useEffect, useState } from "react";
import api from "../../services/api";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import { usePluginspace } from "../../hooks/usePluginspace";
import { Carousel } from "react-responsive-carousel";
import { CatalogItem } from "../../components/CatalogItem";
import { ProductType, SellerInfo } from "../../contexts/OrderContext";
import { useCategory } from "../../hooks/useCategory";
import { CatalogType, CategoryType } from "../../contexts/CategoryContext";
import { useQuery } from "../../hooks/useQuery";
import { useOrder } from "../../hooks/useOrder";
import { SellerBanner } from "../../components/SellerBanner/sellerBanner";
import { useNavigate, useParams } from "react-router-dom";
import EmptyState from "../../components/EmptyStates/EmptyState";
import styles from "./category.module.css"
import { CatalogCarrossel } from "../../components/CatalogCarrosel/CatalogCarrosel";
import { NO_VALUE_SELLER_DISCOUNT } from "../Catalog/auxCatalog";
import { useSellerInfo } from "../../contexts/sellerInfoContext";

export function Category() {
    const { getAppConfig } = useAppConfig();
    const { getToken, registerAccess } = usePluginspace();
    const { getCategories, getCatalogs } = useCategory()
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const { setCpfVendorByLink, setUpdateCustomerCart, setDiscountValue, setSellerInfo } = useSellerInfo();


    const [config, setConfig] = useState<ConfigType | void>();
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState<Array<CategoryType>>([])
    const [catalogs, setCatalogs] = useState<Array<CatalogType>>([])
    const [loadingHeader, setLoadingHeader] = useState(true);

    /*Usado para mostrar botao de visualizer todas as classifications e catalogos */
    const [showAll, setShowAll] = useState(true);
    const [showAllCatalogs, setShowAllCatalogs] = useState(true);
    const [useShadow, setUseShadow] = useState(true);
    /* Variavel utilziada para mostrar nomes */
    const [showCatalogName, setShowCatalogName] = useState(true);
    const [showClassificationName, setShowClassificationName] = useState(true);


    const query = useQuery();
    const orderContext = useOrder();
    const { getCatalogSeller, getSellerInfo } = useOrder();
    useEffect(() => {
        createVendorCart()
        getConfig();
    }, []);

    async function saveInfoSellerLinkCart() {
        if (orderContext.shouldUpdadeCart) {
            const orderToStorage = Object.assign(orderContext);
            await orderToStorage.encryptOrderStorage(orderToStorage)
        }
    }


    useEffect(() => {

        saveInfoSellerLinkCart();

    }, [orderContext.shouldUpdadeCart])


    async function getConfig() {
        setLoading(true);
        setLoadingHeader(true);
        const conf = await getAppConfig()

        if (conf) {
            setShowAll(conf.content.showButtonClassification)
            setShowAllCatalogs(conf.content.showButtonCatalog)
            setUseShadow(!conf.content.removeShadow)

            setShowClassificationName(conf.content.showClassificationName)
            setShowCatalogName(conf.content.showCatalogName)
        }

        setLoadingHeader(false);
        setConfig(conf);
        await getItems(conf);
        setLoading(false);
    }

    async function createVendorCart() {
        if (query.get('vendor') !== undefined && query.get('vendor') !== '' && query.get('vendor') != null) {
            // gerar um carrinho informando qual o vendedor

            const x = query.get("vendor");


            const vendorDataRaw = atob(x!);

            if (!vendorDataRaw) {
                return NO_VALUE_SELLER_DISCOUNT;
            }
            const vendorData = JSON.parse(vendorDataRaw.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":'));

            const code = vendorData.code;
            const cpf = vendorData.cpf;
            const discountValue = await getVendorInfoByCPFOrCode(cpf, code);

            if (!discountValue.sellerInfo.id) {
                return NO_VALUE_SELLER_DISCOUNT;
            }
            const sellerInfo = discountValue.sellerInfo;
            setCpfVendorByLink(sellerInfo.cpf);
            setUpdateCustomerCart(true);
            setDiscountValue(discountValue.discountValue)
            setSellerInfo(discountValue.sellerInfo);
            registerAccess('category', sellerInfo.cpf, undefined, window.location.pathname)
        } else {
            registerAccess('category')
        }
    }

    async function getVendorInfoByCPFOrCode(cpf: string, code: string): Promise<{
        discountValue: number;
        sellerInfo: SellerInfo;
    }> {
        return await api
            .post(
                `/api/users/filter`,
                {
                    type: 'seller',
                },
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (res: any) => {
                if (res.data) {
                    const sellerData = res.data.data.find((e: any) => e.cpf === cpf || e.sellerCode === code.toString());

                    if (sellerData) {
                        const seller: SellerInfo = {
                            cpf: sellerData.cpf,
                            image: sellerData.image,
                            email: sellerData.email,
                            id: sellerData.id,
                            name: sellerData.name,
                            numberPhone: sellerData.numberPhone,
                            sellerCode: sellerData.sellerCode,
                            pluginspaceId: parseInt(sellerData.pluginspaceId),
                        };

                        orderContext.setSellerInfoData(seller);
                        if (sellerData.content) {
                            const content = JSON.parse(sellerData.content);
                            if (content.discount_value) {
                                return {
                                    discountValue: parseInt(content.discount_value),
                                    sellerInfo: seller,
                                };
                            }
                        }

                        return {
                            discountValue: 0,
                            sellerInfo: seller,
                        };
                    }
                }

                return NO_VALUE_SELLER_DISCOUNT;
            })
            .catch((err) => {
                console.log(err);
                return NO_VALUE_SELLER_DISCOUNT;
            });
    }

    async function getItems(conf: ConfigType | void) {
        try {
            let showOutStock = (conf && conf.content && conf.content.pdv && conf.content.pdv.showOutStock) ? conf.content.pdv.showOutStock : false;
            let orderCategory = (conf && conf.content && conf.content.orderCategory) ? conf.content.orderCategory : ''
            const newCategories = await getCategories(showOutStock, orderCategory);
            const newCatalogs = await getCatalogs();
            setCategories(newCategories);

            const sellerInfo = await getSellerInfo()
            const catalogIdF = await getCatalogSeller()

            if (sellerInfo && catalogIdF) {
                const catalogId = window.atob(catalogIdF)
                const newCatalogFiltered: CatalogType[] = []
                // regras -> 
                //mostrar todos que não possuirem vendedor.
                // Mostrar caso possua vendedor, somente aquele que é do link
                //mostrar todos que não possuirem vendedor.
                newCatalogs.map((catalog) => {
                    if (!catalog.sellerCatalog) {
                        newCatalogFiltered.push(catalog)
                    }
                    if (catalog.sellerCatalog && catalog.sellerId && parseInt(catalog.sellerId) === sellerInfo.id) {
                        if (!catalog.isExclusive) {
                            newCatalogFiltered.push(catalog)
                        } else if (catalog.isExclusive && catalog.id === parseInt(catalogId)) {
                            newCatalogFiltered.push(catalog)
                        }
                    }
                })
                setCatalogs(newCatalogFiltered)
            } else {
                setCatalogs(newCatalogs.filter(catalog => !catalog.isExclusive))

            }

        } catch (e) {
            console.log(e)
            setCatalogs([])
            setCategories([])
        }
    }

    useEffect(() => {
        orderContext.getSellerInfo()
    }, [])

    const goToCatalogs = async () => {
        navigate(`/${pluginspace_id}/catalog-list`)
    }
    const goTo = async () => {
        navigate(`/${pluginspace_id}/category-list`)
    }

    return (
        <div className="category">
            <div className="content-category" style={loadingHeader ? { paddingTop: '0px' } : {}}>
                {!loadingHeader && (
                    <Header
                        background={config?.webappcolor.backgroundheader ? config?.webappcolor.backgroundheader : '#F5F5F5'}
                        colorIcon={config?.webappcolor.iconsheader ? config.webappcolor.iconsheader : "#636363"}
                        logo={config?.icon ? config.icon : ''}
                        backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
                        fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
                        noSales={
                            (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
                {loading ?
                    <div style={{ width: '100%', height: `calc(${loadingHeader ? '107vh' : '100vh - 7em'})` }}>
                        <Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
                    </div>
                    :
                    <>
                        {catalogs.length === 0 && categories.length === 0 ? (<>
                            <div className="empty_state_jhkalds">
                                <EmptyState type={"category"} textButton={""} colorIcon={config?.webappcolor.iconsheader
                                    ? config.webappcolor.iconsheader
                                    : "#CEA127"}
                                    noShowBackground
                                />
                            </div>
                        </>) : (
                            <div className={styles.category_container} >
                                {/*Novo baner do vendedor caso o cliente recebeu o link dele */}
                                <SellerBanner />
                                {/*Continuação do fluxo */}
                                {catalogs.length > 0 && (
                                    <>
                                        <div className={styles.category_container_header}>
                                            <span className={styles.title_container}> CATÁLOGOS </span>
                                            {showAllCatalogs && <button onClick={goToCatalogs}><span> Ver todos</span></button>}
                                        </div>

                                        <CatalogCarrossel catalog={catalogs} legendColor={""} showName={showCatalogName} useShadow={useShadow} />

                                        <div className={styles.catalog_divede_line}></div>
                                    </>
                                )
                                }
                                <div className={styles.category_container_header}>
                                    <span className={styles.title_container}> CATEGORIAS</span>
                                    {showAll && <button onClick={goTo}><span> Ver todos</span></button>}
                                </div>
                                <CategoryListAtacado category={categories}
                                    legendColor={config?.webappcolor.fontcategory ? config?.webappcolor.fontcategory : '#FFF'}
                                    noShadow={useShadow}
                                    showName={showClassificationName}
                                />


                            </div>
                        )}

                    </>}
                {!loadingHeader && (
                    <Menu
                        activeMenu="category"
                        fontColor={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
                        activeFontColor={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#000'}
                        backgroundMenu={config?.webappcolor.backgroundfooter ? config?.webappcolor.backgroundfooter : '#F5F5F5'}
                        colorIcons={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
                        highlightColorIcons={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#636363'}
                        backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
                        fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
                        noSales={
                            (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
            </div>
        </div>
    )
}
